var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9368"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.3535 14.562a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm37.293 0a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm-37.293 10.062a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm37.293 0a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938z",
    display: "none",
    fill: "#f00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    className: "powerclip",
    d: "m0.35362 5.8295h47.293v36.341h-47.293zm4.9999 8.733a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm37.293 0a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm-37.293 10.062a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938zm37.293 0a2.5938 2.5938 0 0 0-2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938 2.5938 2.5938 2.5938 0 0 0 2.5938-2.5938 2.5938 2.5938 0 0 0-2.5938-2.5938z",
    fill: "#f00",
    strokeWidth: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.6117 0 0 .66089 -2.6809 -3.8614)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    x: 5.3536224,
    y: 10.829522,
    width: 37.292755,
    height: 26.340956,
    d: "m5.3536 10.83h37.293v26.341h-37.293z",
    clipPath: "url(#clipPath9368)",
    fill: "#57a52d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .81165 0 7.0012)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.3536,
    y: 32.525,
    width: 37.293,
    height: 4.6455,
    fill: "#f6df57"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4c4c4c",
    strokeWidth: 0.44399
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.844 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.666 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.478 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.29 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.103 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.951 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.773 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.585 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.397 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.21 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.931 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.759 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.587 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.415 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.6825 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.5044 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.316 32.525v4.6455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.129 32.525v4.6455"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#525252"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15.125,
    width: 7.5,
    height: 13.062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.25,
    y: 15.125,
    width: 7.5,
    height: 13.062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 15.125,
    width: 7.5,
    height: 13.062
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a45d163a316c73f1119b219bcfa3ffa.svg";
export { ForwardRef as ReactComponent };